import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { useNavigate } from 'react-router-dom';
import Confirmation from '../common/confimation.component';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';

const SeoPages = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [row, setCurrentRow] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    getPages();
  }, []);

  const getPages = () => {
    setLoading(true);
    DataService.getSeoPages()
      .then((response) => {
        setPages(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleAddPage = () => {
    navigate('/add-seo-page');
  };

  const deleteData = (row) => {
    setCurrentRow(row);
    setModalShow(true);
  };

  const updateStatus = () => {
    if (!row) return;

    setLoading(true);
    DataService.deleteSeoPage({ id: row.id })
      .then((response) => {
        toast.success('SEO Page Deleted Successfully.');
        getPages();
        setLoading(false);
        setModalShow(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response?.data?.error || 'Failed to delete page');
        setLoading(false);
        setModalShow(false);
      });
  };

  const columns = [
    {
      name: 'ID',
      selector: row => row.id,
      sortable: true,
      width: '70px',
    },
    {
      name: 'Title',
      selector: row => row.title,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Slug',
      selector: row => row.slug,
      sortable: true,
      wrap: true,
      cell: row => (
        <code style={{ fontSize: '12px', background: '#f1f5f9', padding: '2px 6px', borderRadius: '4px' }}>
          /{row.slug}
        </code>
      )
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
      width: '110px',
      cell: row => (
        <span className={`badge ${row.status === 'published' ? 'bg-success' : 'bg-warning text-dark'}`}>
          {row.status}
        </span>
      )
    },
    {
      name: 'Order',
      selector: row => row.display_order,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Popular',
      selector: row => row.show_in_popular,
      width: '90px',
      cell: row => (
        <span className={`badge ${row.show_in_popular ? 'bg-info' : 'bg-secondary'}`}>
          {row.show_in_popular ? 'Yes' : 'No'}
        </span>
      )
    },
    {
      name: 'Services',
      selector: row => row.show_in_services,
      width: '90px',
      cell: row => (
        <span className={`badge ${row.show_in_services ? 'bg-primary' : 'bg-secondary'}`}>
          {row.show_in_services ? 'Yes' : 'No'}
        </span>
      )
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex gap-2 align-items-center">
          <FontAwesomeIcon
            icon={faEye}
            className="text-info"
            style={{ cursor: 'pointer', fontSize: '14px' }}
            onClick={() => window.open(`/${row.slug}`, '_blank')}
            title="Preview"
          />
          <FontAwesomeIcon
            icon={faEdit}
            className="text-primary"
            style={{ cursor: 'pointer', fontSize: '14px' }}
            onClick={() => editData(row)}
          />
          <FontAwesomeIcon
            icon={faTrash}
            className="text-danger"
            style={{ cursor: 'pointer', fontSize: '14px' }}
            onClick={() => deleteData(row)}
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: '120px',
    }
  ];

  const editData = (data) => {
    navigate('/edit-seo-page', { state: { data } });
  };

  return (
    <>
      <LoaderOverlay loading={loading} />

      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h4>SEO Pages</h4>
          <small className="text-muted">Manage website pages with SEO optimization</small>
        </div>
        <button className="btn btn-success" onClick={handleAddPage}>Add SEO Page</button>
      </div>

      <DataTable
        columns={columns}
        data={pages}
        pagination
        highlightOnHover
        striped
        responsive
        noHeader
      />

      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={updateStatus}
        handleClose={() => setModalShow(false)}
      />
    </>
  );
};

export default SeoPages;
